/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Chat_Dictate_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_cancel = /** @type {((inputs?: Chat_Dictate_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Annuleren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	return /** @type {LocalizedString} */ ("Cancel")
});